export default __webpack_public_path__ + "static/media/DSC05340.2c01fa79.jpg";